import { AccordionSummary, Grid, Typography } from "@mui/material";
import { iObjetivoAprendizaje } from "../../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { FC } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { UseSetLenguajePorPais } from "../../hooks/UseSetLenguajePorPais";
import { useAuthContext } from "../../hooks/Auth";

interface Props {
  objetivo: iObjetivoAprendizaje;
  isExpanded: boolean;
  color: string;
}

const ObjectiveMain: FC<Props> = ({ objetivo, isExpanded, color }) => {
  const { t } = useTranslation();
  UseSetLenguajePorPais();
  const { user } = useAuthContext();

  const IS_FROM_URUGUAY = user?.pais === "UY";

  const objetivoStyles = {
    fontFamily: "Montserrat",
    color,
    fontSize: "0.8rem",
  };

  const ellipsisStyles = isExpanded
    ? {}
    : {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical" as const,
      };

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls={`panel-${objetivo.id_objetivo}-content`}
      id={`panel-${objetivo.id_objetivo}-header`}
    >
      <Grid>
        {/* Código */}
        <Typography
          sx={{
            fontWeight: "bold",
            color: objetivoStyles.color,
            fontSize: "1rem",
          }}
        >
          {objetivo.codigo}
        </Typography>

        {/* Título */}
        <Grid margin={1}>
          {!IS_FROM_URUGUAY && (
            <Typography sx={{ ...objetivoStyles, fontWeight: "bold" }}>
              {t("Objetivo Aprendizaje")}
            </Typography>
          )}

          {/* Objetivo */}
          <Typography sx={{ ...objetivoStyles, ...ellipsisStyles }}>
            {objetivo.objetivo}
          </Typography>
        </Grid>
      </Grid>
    </AccordionSummary>
  );
};

export default ObjectiveMain;
